import { useEffect, useRef, useState } from 'react';
import { imageSrc } from '../lib/format';

export function Gallery({ photos, onLast }: { photos: string[]; onLast: () => void }) {
  const track = useRef<HTMLDivElement>(null);
  const [idx, setIdx] = useState(0);
  const fired = useRef(false);
  useEffect(() => {
    const el = track.current;
    if (!el) return;
    const onScroll = () => {
      const i = Math.round(el.scrollLeft / el.clientWidth);
      setIdx(i);
      if (i >= photos.length - 1 && !fired.current) {
        fired.current = true;
        onLast();
      }
    };
    el.addEventListener('scroll', onScroll, { passive: true });
    return () => el.removeEventListener('scroll', onScroll);
  }, [photos.length, onLast]);
  if (photos.length === 0) return null;
  return (
    <div className="gallery" aria-roledescription="галерея">
      <div className="gallery__track" ref={track}>
        {photos.map((p, i) => (
          <img key={p} src={imageSrc(p) ?? ''} alt={`Фото ${i + 1} из ${photos.length}`} loading={i === 0 ? 'eager' : 'lazy'} decoding="async" />
        ))}
      </div>
      {photos.length > 1 && (
        <div className="gallery__dots" aria-hidden="true">
          {photos.map((_, i) => (
            <i key={i} className={i === idx ? 'is-on' : ''} />
          ))}
        </div>
      )}
    </div>
  );
}
